import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useCallback, useMemo, useEffect } from "react";
import { ExportButton, ExportFieldCustomizer, useToast } from "@perfectserve/library";
import { INTERACTION_EXPORT_FIELDS, EXPORT_FIELDS_CONFIG_VERSION } from "../types/interactions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "@perfectserve/css-styles-react";
import { faTimes } from "@fortawesome/pro-solid-svg-icons";
import InteractionModalContent from "./InteractionDetailModal/InteractionModalContent";
import { processInteractionForModal, handleFieldCustomizationSave } from "../utils/interactionProcessor";
import { handleInteractionDetailExcelExport } from "../utils/interactionDetailExportUtils";
const InteractionDetailModal = ({ interaction, onClose, open }) => {
    const { showToast } = useToast();
    const [selectedTab, setSelectedTab] = useState(0);
    const [showFieldCustomizer, setShowFieldCustomizer] = useState(false);
    const [isClosing, setIsClosing] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const [mountedData, setMountedData] = useState(null);
    const processedInteraction = useMemo(() => processInteractionForModal(mountedData), [mountedData]);
    const availableExportFields = useMemo(() => {
        return INTERACTION_EXPORT_FIELDS.map((field) => field.key);
    }, []);
    const handleClose = useCallback(() => {
        setIsClosing(true);
        setIsVisible(false);
        setTimeout(() => {
            onClose();
            setIsClosing(false);
        }, 200);
    }, [onClose]);
    const handleExcelExport = async () => {
        try {
            if (!processedInteraction)
                return;
            await handleInteractionDetailExcelExport(processedInteraction);
        }
        catch (error) {
            console.error("Excel export failed:", error);
            showToast({
                message: "Excel export failed. Please try again.",
                type: "error",
                position: "top-right",
            });
        }
    };
    const handleTabChange = useCallback((newTab) => {
        setSelectedTab(newTab);
    }, []);
    useEffect(() => {
        if (open) {
            setMountedData(interaction);
            setSelectedTab(0);
            setIsClosing(false);
            const timer = setTimeout(() => setIsVisible(true), 10);
            return () => clearTimeout(timer);
        }
        else {
            setIsVisible(false);
            const timer = setTimeout(() => {
                setMountedData(null);
            }, 300);
            return () => clearTimeout(timer);
        }
    }, [open, interaction]);
    if ((!open && !isClosing) || !processedInteraction)
        return null;
    return (_jsxs("div", { className: `interaction-modal-overlay ${isClosing ? "closing" : ""}`, onClick: handleClose, style: {
            opacity: isVisible ? 1 : 0,
            transition: "opacity 0.2s ease-out",
        }, children: [_jsxs("div", { className: `interaction-modal-content ${isClosing ? "closing" : ""}`, onClick: (e) => e.stopPropagation(), style: {
                    opacity: isVisible ? 1 : 0,
                    transition: "opacity 0.2s ease-out",
                }, children: [_jsxs("div", { className: "interaction-modal-header", children: [_jsxs("div", { className: "interaction-modal-tabs", children: [_jsx("button", { onClick: () => handleTabChange(0), className: `interaction-modal-tab ${selectedTab === 0 ? "active" : ""}`, children: "Interaction Detail" }), _jsx("button", { onClick: () => handleTabChange(1), className: `interaction-modal-tab ${selectedTab === 1 ? "active" : ""}`, children: "Conversation" })] }), _jsx("div", { className: "mr-15", children: _jsx(ExportButton, { title: `Interaction_${(processedInteraction === null || processedInteraction === void 0 ? void 0 : processedInteraction.Id) || "Detail"}`, onExcelExport: handleExcelExport, exportElementId: "interaction-detail-content", variant: "links", buttonStyle: { fontSize: "12px" }, enableFieldCustomization: true, availableFields: availableExportFields, onFieldCustomizationOpen: () => setShowFieldCustomizer(true), hidePdfExport: true }) }), _jsx("button", { onClick: handleClose, className: "interaction-modal-close-btn", children: _jsx(FontAwesomeIcon, { icon: faTimes }) })] }), _jsx("div", { id: "interaction-detail-content", className: "interaction-modal-body", children: mountedData && (_jsx(InteractionModalContent, { mountedData: mountedData, processedInteraction: processedInteraction, selectedTab: selectedTab })) })] }), _jsx(ExportFieldCustomizer, { isOpen: showFieldCustomizer, onClose: () => setShowFieldCustomizer(false), availableFields: availableExportFields, storageKey: "interaction-detail-export-fields", onSave: handleFieldCustomizationSave, sampleData: mountedData ? [mountedData] : [], fieldDefinitions: INTERACTION_EXPORT_FIELDS, configVersion: EXPORT_FIELDS_CONFIG_VERSION })] }));
};
export default React.memo(InteractionDetailModal);
//# sourceMappingURL=InteractionDetailModal.js.map